import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tab-wrapper disable-context-menu" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "carousel-inner" }
const _hoisted_4 = { class: "carousel-item active" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["data-bs-target"]
const _hoisted_8 = { "aria-hidden": "true" }
const _hoisted_9 = ["alt"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Previous", -1)
const _hoisted_11 = ["data-bs-target"]
const _hoisted_12 = { "aria-hidden": "true" }
const _hoisted_13 = ["alt"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Next", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "text-story-block d-none d-lg-block"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["id", "poster"]
const _hoisted_23 = ["src"]
const _hoisted_24 = ["label", "src", "srclang"]
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = {
  key: 0,
  class: "story-title"
}
const _hoisted_27 = {
  key: 1,
  class: "user-info user-info w-100 justify-content-start d-none d-lg-flex"
}
const _hoisted_28 = {
  key: 0,
  class: "mx-2"
}
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "author-name" }
const _hoisted_32 = { class: "user-info user-info d-flex w-100 justify-content-start d-lg-none" }
const _hoisted_33 = {
  key: 0,
  class: "mx-2"
}
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "author-name" }
const _hoisted_37 = {
  key: 0,
  class: "d-none d-lg-block"
}
const _hoisted_38 = { class: "row" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = {
  class: "collapse d-lg-none p-0 px-2 m-0 w-100",
  id: "collapseTabBtn"
}
const _hoisted_41 = { class: "card card-body" }
const _hoisted_42 = {
  key: 0,
  class: "row"
}
const _hoisted_43 = ["innerHTML"]

import { PlaylistStoryDto } from '@/models/PlaylistPageTypes'
import { ref, computed } from 'vue'
import { usePlaylistStore } from '@/stores/playlistStore'
import { STORY_TYPE } from '@/models/StoryTypeEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'PlaylistPagePresentedStory',
  props: {
    story: null
  },
  emits: ["videoend"],
  setup(__props: any, { emit: videoEmit }: { emit: ({
    (event: 'videoend', payload: PlaylistStoryDto): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    story: PlaylistStoryDto
};

const playlistStore = usePlaylistStore()

const contentVideo = ref<HTMLVideoElement | undefined>(undefined)

const altSliderNext = computed(() => playlistStore.getLocalization('Accessability.Images.SliderNext'))
const altSliderPrev = computed(() => playlistStore.getLocalization('Accessability.Images.SliderPrev'))
const hideArrowOnButton = computed(() => !props.story.Content)





function onVideoEnd(story: PlaylistStoryDto) {
    if (playlistStore.autoplayMode) {
        videoEmit('videoend', story)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (__props.story.ContentMedia.length > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: 'playlist-carousel' + __props.story.KeyId,
            class: "carousel slide"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (__props.story.ContentMedia[0])
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: __props.story.ContentMedia[0].Url,
                      alt: __props.story.ContentMedia[0].Alt,
                      class: "img-fluid mx-auto d-block text-center"
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.story.ContentMedia.slice(1), (content, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index + '-' + __props.story.KeyId,
                  class: "carousel-item"
                }, [
                  _createElementVNode("img", {
                    src: content.Url,
                    alt: content.Alt,
                    class: "img-fluid mx-auto d-block text-center"
                  }, null, 8, _hoisted_6)
                ]))
              }), 128))
            ]),
            _createElementVNode("button", {
              class: "carousel-control-prev",
              type: "button",
              "data-bs-target": '#playlist-carousel' + __props.story.KeyId,
              "data-bs-slide": "prev"
            }, [
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("img", {
                  src: "images/playlist-slider-right.svg",
                  alt: _unref(altSliderPrev)
                }, null, 8, _hoisted_9)
              ]),
              _hoisted_10
            ], 8, _hoisted_7),
            _createElementVNode("button", {
              class: "carousel-control-next",
              type: "button",
              "data-bs-target": '#playlist-carousel' + __props.story.KeyId,
              "data-bs-slide": "next"
            }, [
              _createElementVNode("span", _hoisted_12, [
                _createElementVNode("img", {
                  src: "images/playlist-slider-left.svg",
                  alt: _unref(altSliderNext)
                }, null, 8, _hoisted_13)
              ]),
              _hoisted_14
            ], 8, _hoisted_11)
          ], 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (__props.story.Type === _unref(STORY_TYPE).Text && __props.story.Content)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: "inner-text-story-box",
                    style: _normalizeStyle({ '--scroll-color': __props.story.PreviewColor })
                  }, [
                    (__props.story.Title)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_17, _toDisplayString(__props.story.Title), 1))
                      : _createCommentVNode("", true),
                    (__props.story.Storyteller.Name)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "text-story-storyteller",
                          style: _normalizeStyle({ color: __props.story.PreviewColor ?? 'inherit' })
                        }, [
                          _createElementVNode("p", null, _toDisplayString(__props.story.Storyteller.Name), 1)
                        ], 4))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", {
                      class: "text-break row",
                      innerHTML: __props.story.Content
                    }, null, 8, _hoisted_18)
                  ], 4)
                ]))
              : (__props.story.Type === _unref(STORY_TYPE).Image)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (__props.story.ContentMedia[0])
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "img-fluid mx-auto d-block text-center",
                          src: __props.story.ContentMedia[0].Url,
                          alt: __props.story.ContentMedia[0].Alt
                        }, null, 8, _hoisted_20))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("video", {
                      ref_key: "contentVideo",
                      ref: contentVideo,
                      id: __props.story.KeyId + '-player',
                      playsinline: "",
                      controls: "",
                      controlsList: "nodownload",
                      preload: "metadata",
                      poster: __props.story?.Poster?.Url ?? '',
                      onEnded: _cache[0] || (_cache[0] = ($event: any) => (onVideoEnd(__props.story)))
                    }, [
                      _createElementVNode("source", {
                        src: __props.story.ContentMedia[0].Url,
                        type: "video/mp4"
                      }, null, 8, _hoisted_23),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.story.Subtitles, (subtitles) => {
                        return (_openBlock(), _createElementBlock("track", {
                          key: subtitles.KeyId,
                          kind: "captions",
                          label: subtitles.SubtitlesTitle,
                          src: subtitles.SubtitlesFile,
                          srclang: subtitles.SubtitlesLang,
                          default: ""
                        }, null, 8, _hoisted_24))
                      }), 128))
                    ], 40, _hoisted_22)
                  ]))
          ]))
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("button", {
        class: _normalizeClass(["btn btn-tab-content collapsed", _unref(hideArrowOnButton) ? 'hidden-arrow' : '']),
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#collapseTabBtn",
        "aria-expanded": "false",
        "aria-controls": "collapseTabBtn"
      }, [
        (__props.story.Title && __props.story.Type !== _unref(STORY_TYPE).Text)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(__props.story.Title), 1))
          : _createCommentVNode("", true),
        (__props.story.Type !== _unref(STORY_TYPE).Text)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              (__props.story.Storyteller.Image.Url)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("img", {
                      class: "img-fluid mx-auto d-block",
                      src: __props.story.Storyteller.Image.Url,
                      alt: __props.story.Storyteller.Image.Alt
                    }, null, 8, _hoisted_29)
                  ]))
                : _createCommentVNode("", true),
              (__props.story.Storyteller.Name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("p", _hoisted_31, _toDisplayString(__props.story.Storyteller.Name), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_32, [
          (__props.story.Storyteller.Image.Url)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("img", {
                  class: "img-fluid mx-auto d-block",
                  src: __props.story.Storyteller.Image.Url,
                  alt: __props.story.Storyteller.Image.Alt
                }, null, 8, _hoisted_34)
              ]))
            : _createCommentVNode("", true),
          (__props.story.Storyteller.Name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("p", _hoisted_36, _toDisplayString(__props.story.Storyteller.Name), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      (__props.story.Type != _unref(STORY_TYPE).Text && __props.story.Content)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("p", {
                class: "text-break col-lg-9",
                innerHTML: __props.story.Content
              }, null, 8, _hoisted_39)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          (__props.story.Content)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createElementVNode("p", {
                  class: "row-col",
                  innerHTML: __props.story.Content
                }, null, 8, _hoisted_43)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})